import React from 'react';

import { Box, Button, Dialog, H1, Text } from '@betterment/samba-react';

interface Props {
  closeHandler: () => void;
  submitHandler: () => void;
  isOpen: boolean;
}

export const DismissalModal: React.FC<React.PropsWithChildren<Props>> = ({ closeHandler, submitHandler, isOpen }) => {
  return (
    <Dialog open={isOpen} onOpenChange={closeHandler}>
      <Dialog.Content size="large" css={{ p: 'space.400' }}>
        <Dialog.Title>
          <H1 variant="title300">Are you sure?</H1>
        </Dialog.Title>
        <Dialog.Description>
          <Box css={{ mt: 'space.200', pb: '96px' }}>
            <Text variant="text200" color="text.weak">
              This action can’t be undone.
            </Text>
          </Box>
        </Dialog.Description>
        <Box css={{ display: 'flex', gap: 'space.200' }}>
          <Button
            css={{ bg: 'background.critical.strong', _hover: { background: 'background.critical.strong' } }}
            variant="solidPrimary"
            onClick={() => submitHandler()}
          >
            Yes, remove
          </Button>
          <Button variant="solidSecondary" onClick={() => closeHandler()}>
            Nevermind
          </Button>
        </Box>
      </Dialog.Content>
    </Dialog>
  );
};
